import { AspenRequestsService, PaginatedDTO_RequestDTO_ } from '../client'
import { usePaginatedData } from './usePaginatedData'

export const useRequests = (initialPage = 1, initialLimit = 10, initialSort = '', initialFilters = {}) => {
    return usePaginatedData<PaginatedDTO_RequestDTO_>(AspenRequestsService.indexRequestsGet, initialPage, initialLimit, initialSort, initialFilters)
}
